import { NgModule } from '@angular/core';

import { HeroModule } from 'src/app/shared/components/hero/hero.module';

import { SelfAttendanceSuccessComponent } from './success.component';
import {InvoiceModule} from '../../shared/components/invoice/invoice.module';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
  imports: [
    HeroModule,
    InvoiceModule,
    CommonModule,
    MatButtonModule,
    
  ],
  exports: [
    SelfAttendanceSuccessComponent
  ],
  providers: [
  ],
  declarations: [
    SelfAttendanceSuccessComponent
  ]
})

export class SelfAttendanceSuccessModule { }
